<template>
	<ul v-if="loading" class="list">
		<li :key="i" v-for="(item, i) in items" class="item">
			<el-skeleton style="width: 100%" :loading="loading" animated>
				<template slot="template">
					<el-container>
						<div style="display: inline-flex; align-items: center">
							<el-skeleton-item style="width: 40px; height: 40px; margin-right: 10px" />
						</div>
						<el-main style="padding: 0px; margin-left: 20px; width: 40%; margin-top: 12px">
							<el-skeleton-item variant="h4" style="width: 80%" />
						</el-main>
					</el-container>
					<el-container>
						<el-main style="padding: 0px; width: 50%; margin-top: 20px">
							<el-skeleton-item variant="text" style="width: 70%" />
							<el-skeleton-item variant="text" style="width: 50%" />
						</el-main>
					</el-container>
				</template>
			</el-skeleton>
		</li>
	</ul>
</template>

<script>
export default {
	props: {
		loading: Boolean,
		items: Number,
	},
};
</script>

<style scoped>
.list {
	margin: 0;
	list-style-type: none;
	padding: 2px;
	display: flex;
	align-items: stretch;
	flex-wrap: wrap;
}

.item {
	background-color: white;
	box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
	border-radius: 4px;
	padding: 20px;
	align-items: center;
	margin-bottom: 20px;
	height: 200px;
	width: 250px;
	margin-right: 20px;
}
</style>
